import Box from "@mui/material/Box";
import React from "react";
import {Switch} from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export default (data, key) => {
    const onClick = (e) => {
        data.onCallback({
            target:{
                name: data.name,
                value: e.target.checked,
            }
        })
    }

    return (<FormGroup key={key}>
               <Box display={"flex"}
                    flexDirection={'column'}
                    alignItems={"center"}>
                   <FormControlLabel
                       labelPlacement="start"
                       margin="normal"
                       control={<Switch checked={data.value === 'true' ? true : data.value === true ? true : false }
                                                      onClick={onClick}
                                                      id={`${data.name}-${key}`}
                                                      label={data.headerName}
                                                      value={data.value}
                                                      name={data.name}

                   />} label={data.headerName}/>
               </Box>
        </FormGroup>)
}